// CA.txt content - Token contract information
export const CA_CONTENT = `╔════════════════════════════════════════════════════════════════╗
║                     TUX TOKEN CONTRACT                        ║
╚════════════════════════════════════════════════════════════════╝

  Contract Address TUX (CA):
  ─────────────────────
  4qrGNfNeNFsdNJC6LrNZ9CQg8Vfqtq4Dd9bP6pn7pump

  ═══════════════════════════════════════════════════════════════

  Official Links:
  ───────────────
  • Website:   https://tuxlinux.xyz
  • X/Twitter: https://x.com/i/communities/2015539003534041135

  ════════════════════════════════════════════════════════════════
  
                    🐧 TUX - The Linux Penguin Memecoin 🐧
`;

// ABOUT.md content - Project information
export const ABOUT_CONTENT = `# TUX - The Linux Penguin Memecoin
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

## About TUX
────────────
I'm building TUX as a fun Linux-penguin memecoin experience.
Born from the spirit of open-source and the beloved Tux mascot,
this project brings the nostalgia of classic Linux interfaces
to the world of cryptocurrency.

## Our Mission
──────────────
• Celebrate the Linux community and open-source culture
• Create a unique, nostalgic crypto experience
• Build a community of penguin lovers and Linux enthusiasts
• Have fun while exploring the intersection of tech and memes

## Socials
──────────
Website:   https://tuxlinux.xyz
X/Twitter: https://x.com/i/communities/2015539003534041135

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

         "In open source, we trust. In TUX, we meme."
                        
                              🐧
`;

// Help command output
export const HELP_CONTENT = `
TUX OS Terminal - Available Commands
════════════════════════════════════

  help           Show this help message
  ls             List files in current directory
  cat <file>     Display contents of a file
  open <file>    Open a file in a new window
  clear          Clear the terminal screen

Available Files:
────────────────
  CA.txt         Token contract information
  ABOUT.md       About TUX project
  TUX-RACER      Classic penguin racing game
  SUPERTUX       Classic platformer game

Examples:
─────────
  $ cat CA.txt
  $ open ABOUT.md
  $ open TUX-RACER
  $ open SUPERTUX

`;

// LS command output
export const LS_CONTENT = `CA.txt  ABOUT.md  TUX-RACER  SUPERTUX`;
